import { render, staticRenderFns } from "./SendBalance.vue?vue&type=template&id=c6e92d70"
import script from "./SendBalance.vue?vue&type=script&lang=js"
export * from "./SendBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports